var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoodle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 107,
    viewBox: "0 0 231 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65662 60.8025C13.688 83.9889 41.7297 100.405 68.7274 96.5536C95.7251 92.7026 117.783 69.1456 116.852 45.2104C116.519 36.8023 112.029 27.2189 102.652 25.8247C94.0465 24.5707 85.9807 31.1097 82.522 38.2575C72.9083 58.2315 90.8541 81.948 114.481 86.3345C138.154 90.7151 163.349 79.542 179.687 63.1768C196.026 46.8115 205.013 25.972 212.811 5.43676",
    stroke: "#3F78E0",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.658 17.778L213.306 4.47179L220.896 26.5222",
    stroke: "#3F78E0",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221.41,
    height: 79.4057,
    fill: "white",
    transform: "translate(0.681641 27.3188) rotate(-7.05266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodle2);
export default __webpack_public_path__ + "static/media/doodle2.62adbaad35160bfdde3a885b5a7aa43d.svg";
export { ForwardRef as ReactComponent };